import { useState, useCallback } from 'react';
import { DataLoader } from '../../components/RepricerDashboard/DataLoader';
import RepricerMetrics from '../../components/RepricerDashboard/RepricerMetrics';
import PricingPowerTable from '../../components/RepricerDashboard/PricingPowerTable';

export default function DashboardPage() {
  const [data, setData] = useState<any[]>([]);
  const [lastUpdated, setLastUpdated] = useState<string>('');

  const handleDataLoaded = useCallback((loadedData: any[], timestamp?: string) => {
    setData(loadedData);
    if (timestamp) setLastUpdated(timestamp);
  }, []);

  return (
    <DataLoader 
      dataUrl="graphql"
      onDataLoaded={handleDataLoaded}
    >
      <RepricerMetrics data={data} lastUpdated={lastUpdated} />
      <PricingPowerTable />
    </DataLoader>
  );
}
